import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=7afe554e"
import script from "./modal.js?vue&type=script&lang=js&external"
export * from "./modal.js?vue&type=script&lang=js&external"
import style0 from "./modal.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports